import { Reveal, Btn, Eyebrow } from "../Bits";
import { useSite, whatsappLink } from "../../context/SiteContext";

const FinalCta = () => {
  const { settings } = useSite();

  return (
    <section data-testid="home-final-cta" className="relative overflow-hidden bg-[#0F4C81]">
      <div className="mako-grid-bg-dark absolute inset-0 opacity-40" aria-hidden="true" />
      <div className="relative mx-auto grid max-w-[1400px] gap-12 px-6 py-20 lg:grid-cols-12 lg:items-end lg:px-10 lg:py-32">
        <Reveal className="lg:col-span-7">
          <Eyebrow tone="light">Next step</Eyebrow>
          <h2 className="mt-7 font-display text-3xl font-bold uppercase leading-[1] tracking-tight text-white sm:text-4xl lg:text-[3.5rem]">
            Build a better
            <span className="block">training surface.</span>
          </h2>
          <p className="mt-8 max-w-xl text-sm leading-relaxed text-white/80 sm:text-base">
            Tell us about your facility and we will help identify the right mat and wall-pad
            solution.
          </p>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-5">
          <div className="flex flex-col gap-3 sm:flex-row lg:justify-end">
            <Btn to="/contact" variant="white" data-testid="final-quote-cta">
              Request a quote
            </Btn>
            <Btn
              href={whatsappLink(settings)}
              variant="ghostLight"
              data-testid="final-whatsapp-cta"
            >
              WhatsApp MAKO
            </Btn>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCta;
